module.exports = __webpack_public_path__ + "media/25.25a72e03.webm";